











import { State, Getter, Mutation, Action } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Data, Filter, SearchFilter } from '@/models/dynamiclist';
import _ from 'lodash';
import { FilterQuery, SearchFilterQuery } from '../../models/dynamiclist';

@Component({})
export default class SearchFilterComponent extends Vue {

    @Prop({ required: true })
    public filter!: SearchFilter;

    public query!: SearchFilterQuery;

    @Action('fetchResultsDebounced')
    public fetchResultsDebounced!: () => void;

    @Getter('filterQuery')
    private getFilterQuery!: (filter: Filter) => FilterQuery<any>;

    @Mutation('setFilterQuery')
    private setFilterQuery!: (cmd: { filterId: string, filterQuery: FilterQuery<any> }) => void;

    constructor() {
        super();
        this.query = {} as SearchFilterQuery;
    }

    public mounted() {
        const query = this.getFilterQuery(this.filter);

        if (query) {
            this.query = query;
        } else {
            this.query = { filterTemplateId: this.filter.templateId, value: '' } as SearchFilterQuery;
        }

        this.setFilterQuery({
            filterId: this.filter.id,
            filterQuery: this.query
        });
    }
}

